import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthProvider';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Navbar from './components/layout/Navbar';
import HomePage from './components/pages/HomePage';
import LoginPage from './components/auth/LoginPage';
import Dashboard from './components/pages/Dashboard';
import CreateGroup from './components/pages/CreateGroup';
import AddExpense from './components/pages/AddExpense';
import GroupDetails from './components/pages/GroupDetails';
import MyTransactions from './components/pages/MyTransactions';
import NotificationSystem from './components/ui/NotificationSystem';

const App = () => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Navbar showMobileMenu={showMobileMenu} setShowMobileMenu={setShowMobileMenu} />
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/create-group" element={
              <ProtectedRoute>
                <Navbar showMobileMenu={showMobileMenu} setShowMobileMenu={setShowMobileMenu} />
                <CreateGroup />
              </ProtectedRoute>
            } />
            <Route path="/add-expense" element={
              <ProtectedRoute>
                <Navbar showMobileMenu={showMobileMenu} setShowMobileMenu={setShowMobileMenu} />
                <AddExpense />
              </ProtectedRoute>
            } />
            <Route path="/group/:id" element={
              <ProtectedRoute>
                <Navbar showMobileMenu={showMobileMenu} setShowMobileMenu={setShowMobileMenu} />
                <GroupDetails />
              </ProtectedRoute>
            } />
            <Route path="/transactions" element={
              <ProtectedRoute>
                <Navbar showMobileMenu={showMobileMenu} setShowMobileMenu={setShowMobileMenu} />
                <MyTransactions />
              </ProtectedRoute>
            } />
          </Routes>
          
          {/* Global Notification System */}
          <NotificationSystem />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;